import React from 'react';

const SportEventContext = React.createContext(null);
export default SportEventContext;
